import CheckIcon from '@mui/icons-material/Check'
import DeleteIcon from '@mui/icons-material/Delete'
import EditIcon from '@mui/icons-material/Edit'
import InfoIcon from '@mui/icons-material/Info'
import Search from '@mui/icons-material/Search'
import {
	Box,
	Button,
	Checkbox,
	Chip,
	Container,
	IconButton,
	InputAdornment,
	OutlinedInput,
	Stack,
} from '@mui/material'
import { DataGrid, GridColDef, GridRenderCellParams } from '@mui/x-data-grid'

import SubPageHeader from 'components/SubPageHeader'

import { styles } from './Admin.styles'
import { UserStatus, adminDummyData } from './AdminDummyData'

export const TEST_ID = 'admin-page'

const StatusChip = ({ status }: { status: UserStatus }) => {
	if (status === 'Account Created') {
		return (
			<Chip
				icon={<CheckIcon sx={styles.statusChipIcon} />}
				label="Account Created"
				variant="outlined"
				size="small"
				sx={styles.statusChip}
			/>
		)
	}
	return (
		<Chip
			icon={<InfoIcon sx={styles.statusChipIcon} />}
			label="Setup Pending"
			variant="outlined"
			size="small"
			sx={styles.statusChip}
		/>
	)
}

const columns: GridColDef[] = [
	{
		field: 'checkbox',
		headerName: '',
		width: 50,
		sortable: false,
		renderCell: () => <Checkbox size="medium" />,
	},
	{ field: 'company', headerName: 'Company', flex: 1, minWidth: 140 },
	{ field: 'userName', headerName: 'User Name', flex: 1, minWidth: 120 },
	{
		field: 'userEmail',
		headerName: 'User Email',
		flex: 1,
		minWidth: 160,
		renderCell: (params: GridRenderCellParams) => (
			<Box
				component="a"
				href={`mailto:${params.value}`}
				sx={styles.emailLink}
			>
				{params.value}
			</Box>
		),
	},
	{
		field: 'userStatus',
		headerName: 'User Status',
		flex: 1,
		minWidth: 160,
		renderCell: (params: GridRenderCellParams) => (
			<StatusChip status={params.value as UserStatus} />
		),
	},
	{ field: 'userRole', headerName: 'User Role', flex: 1, minWidth: 120 },
	{
		field: 'licenseExpiration',
		headerName: 'License Expiation',
		flex: 1,
		minWidth: 150,
	},
	{
		field: 'actions',
		headerName: 'Change Details',
		width: 130,
		sortable: false,
		renderCell: () => (
			<Box sx={styles.actionsCell}>
				<IconButton size="medium" sx={styles.actionsCellIcon}>
					<EditIcon fontSize="medium" />
				</IconButton>
				<IconButton size="medium" sx={styles.actionsCellIcon}>
					<DeleteIcon fontSize="medium" />
				</IconButton>
			</Box>
		),
	},
]

const AdminPage = () => {
	return (
		<Stack sx={styles.StackContainer}>
			<SubPageHeader
				title="User Management"
				subtitle="Manage Brainstorm teams and users here"
				backgroundGradient="linear-gradient(90deg, #9DCDF2 0%, #BDDEF6 100%)"
			/>

			<Box sx={styles.ContentBox}>
				<Container maxWidth={'xl'} sx={{ ...styles.list }}>
					<Box sx={styles.SearchRow}>
						<OutlinedInput
							startAdornment={
								<InputAdornment position="start">
									<IconButton>
										<Search />
									</IconButton>
								</InputAdornment>
							}
							placeholder="Search..."
							sx={styles.searchBarStyle}
						/>
						<Button
							color="secondary"
							variant="outlined"
							size="medium"
							sx={styles.addNewUsersButton}
						>
							Add New Users
						</Button>
					</Box>

					<Box sx={styles.dataGridWrapper}>
						<DataGrid
							rows={adminDummyData}
							columns={columns}
							initialState={{
								pagination: {
									paginationModel: { pageSize: 10 },
								},
							}}
							pageSizeOptions={[10, 25, 50]}
							disableRowSelectionOnClick
							sx={styles.dataGrid}
						/>
					</Box>
				</Container>
			</Box>
		</Stack>
	)
}

export default AdminPage
